var map = {
	"./adult/nn/5 1 Leseforstaelse Intro.mp3": 659,
	"./adult/no/5 1 Leseforstaelse Intro.mp3": 660,
	"./youth/de/5 1 Leseforstaelse Intro.mp3": 661,
	"./youth/nn/5 1 Leseforstaelse Intro.mp3": 662,
	"./youth/no/5 1 Leseforstaelse Intro.mp3": 663,
	"./youth/se/5 1 Leseforstaelse Intro.mp3": 664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 658;